export type Lang = "ar" | "en";

export const T = {
  loading: { ar: "جاري التحميل...", en: "Loading..." },
  save: { ar: "حفظ", en: "Save Changes" },
  cancel: { ar: "إلغاء", en: "Cancel" },
  delete: { ar: "حذف", en: "Delete" },
  edit: { ar: "تعديل", en: "Edit" },
  create: { ar: "إنشاء", en: "Create" },
  search: { ar: "بحث", en: "Search" },
  active: { ar: "نشط", en: "Active" },
  inactive: { ar: "غير نشط", en: "Inactive" },
  unlimited: { ar: "غير محدود", en: "Unlimited" },
  actions: { ar: "إجراءات", en: "Actions" },
  status: { ar: "الحالة", en: "Status" },
  name: { ar: "الاسم", en: "Name" },
  email: { ar: "البريد الإلكتروني", en: "Email" },
  yes: { ar: "نعم", en: "Yes" },
  no: { ar: "لا", en: "No" },
  noData: { ar: "لا توجد بيانات", en: "No data found" },
  prev: { ar: "السابق", en: "Previous" },
  next: { ar: "التالي", en: "Next" },
  confirm: { ar: "تأكيد", en: "Confirm" },
  logout: { ar: "تسجيل الخروج", en: "Logout" },
  free: { ar: "مجاني", en: "Free" },
  perDay: { ar: "/ شهر", en: "/ month" },

  // Nav
  overview: { ar: "نظرة عامة", en: "Overview" },
  foodDb: { ar: "قاعدة الأغذية", en: "Food Database" },
  analysisHistory: { ar: "سجل التحليلات", en: "Analysis History" },
  users: { ar: "المستخدمون", en: "Users" },
  plans: { ar: "خطط الاشتراك", en: "Subscription Plans" },
  settings: { ar: "الإعدادات", en: "Settings" },

  // Plans page
  newPlan: { ar: "خطة جديدة", en: "New Plan" },
  editPlan: { ar: "تعديل الخطة", en: "Edit Plan" },
  createPlan: { ar: "إنشاء الخطة", en: "Create Plan" },
  planNameAr: { ar: "الاسم (عربي)", en: "Name (Arabic)" },
  planNameEn: { ar: "الاسم (إنجليزي)", en: "Name (English)" },
  price: { ar: "السعر", en: "Price" },
  currency: { ar: "العملة", en: "Currency" },
  billingCycle: { ar: "دورة الفواتير", en: "Billing Cycle" },
  monthly: { ar: "شهري", en: "Monthly" },
  yearly: { ar: "سنوي", en: "Yearly" },
  dailyTextLimit: { ar: "حد البحث النصي / شهر", en: "Text searches / month" },
  dailyImageLimit: { ar: "حد الصور / شهر", en: "Images / month" },
  noLimit: { ar: "بدون حد شهري", en: "No monthly limit" },
  enableLimit: { ar: "تفعيل الحد الشهري", en: "Enable monthly limit" },
  features: { ar: "المميزات (سطر لكل ميزة)", en: "Features (one per line)" },
  sortOrder: { ar: "الترتيب", en: "Sort Order" },
  bulkUpdate: { ar: "تحديث جماعي للحدود", en: "Bulk Update Limits" },
  bulkUpdateDesc: { ar: "تطبيق هذه الحدود على جميع الخطط دفعة واحدة", en: "Apply these limits to all plans at once" },
  applyToAll: { ar: "تطبيق على الكل", en: "Apply to All" },
  textSearches: { ar: "بحث نصي", en: "Text searches" },
  imageScans: { ar: "تحليل صور", en: "Image scans" },
  planDeleted: { ar: "تم حذف الخطة", en: "Plan deleted" },
  planCreated: { ar: "تم إنشاء الخطة", en: "Plan created" },
  planUpdated: { ar: "تم تحديث الخطة", en: "Plan updated" },
  bulkUpdated: { ar: "تم تحديث جميع الخطط", en: "All plans updated" },
  confirmDeletePlan: { ar: "هل تريد حذف هذه الخطة؟", en: "Delete this plan?" },
  noPlanYet: { ar: "لا توجد خطط بعد. أنشئ أول خطة.", en: "No plans yet. Create your first plan." },
  managePlans: { ar: "إدارة الخطط المجانية والمدفوعة", en: "Manage free and paid subscription plans" },

  // Users page
  premium: { ar: "مميز", en: "Premium" },
  basic: { ar: "مجاني", en: "Free" },
  locked: { ar: "محجوب", en: "Locked" },
  unlocked: { ar: "غير محجوب", en: "Unlocked" },
  unlock: { ar: "رفع الحجب", en: "Unlock" },
  provider: { ar: "طريقة التسجيل", en: "Provider" },
  plan: { ar: "الخطة", en: "Plan" },
  joinDate: { ar: "تاريخ التسجيل", en: "Join Date" },
  editUser: { ar: "تعديل المستخدم", en: "Edit User" },
  resetPassword: { ar: "إعادة تعيين كلمة المرور", en: "Reset Password" },
  newPassword: { ar: "كلمة المرور الجديدة", en: "New Password" },
  confirmDeleteUser: { ar: "هل تريد حذف هذا المستخدم نهائياً؟", en: "Permanently delete this user?" },
  noUsers: { ar: "لا يوجد مستخدمون", en: "No users found" },
  searchUsers: { ar: "بحث بالاسم أو البريد...", en: "Search by name or email..." },
  totalUsers: { ar: "إجمالي المستخدمين", en: "Total Users" },
  passwordUpdated: { ar: "تم تحديث كلمة المرور", en: "Password updated" },
  userUpdated: { ar: "تم تحديث المستخدم", en: "User updated" },
  userDeleted: { ar: "تم حذف المستخدم", en: "User deleted" },
  userUnlocked: { ar: "تم رفع الحجب", en: "User unlocked" },
  failedAttempts: { ar: "محاولات فاشلة", en: "Failed attempts" },

  // History page
  type: { ar: "النوع", en: "Type" },
  score: { ar: "درجة التوافق", en: "Score" },
  date: { ar: "التاريخ", en: "Date" },
  query: { ar: "الاستعلام", en: "Query" },
  details: { ar: "التفاصيل", en: "Details" },
  text: { ar: "نص", en: "Text" },
  image: { ar: "صورة", en: "Image" },
  label: { ar: "ملصق", en: "Label" },
  noHistory: { ar: "لا يوجد سجل", en: "No history found" },
  allowed: { ar: "مسموح", en: "Allowed" },
  forbidden: { ar: "ممنوع", en: "Forbidden" },
  conditional: { ar: "مشروط", en: "Conditional" },
  unknown: { ar: "غير معروف", en: "Unknown" },
  ingredients: { ar: "المكونات", en: "Ingredients" },
  explanation: { ar: "التفسير", en: "Explanation" },
  itemDeleted: { ar: "تم الحذف", en: "Item deleted" },

  // Foods page
  foodName: { ar: "اسم الطعام", en: "Food Name" },
  foodStatus: { ar: "حكم الطعام", en: "Status" },
  addFood: { ar: "إضافة طعام", en: "Add Food" },
  editFood: { ar: "تعديل الطعام", en: "Edit Food" },
  bulkImport: { ar: "استيراد جماعي", en: "Bulk Import" },
  exportCSV: { ar: "تصدير CSV", en: "Export CSV" },
  foodCreated: { ar: "تم إضافة الطعام", en: "Food created" },
  foodUpdated: { ar: "تم تحديث الطعام", en: "Food updated" },
  foodDeleted: { ar: "تم حذف الطعام", en: "Food deleted" },
  exporting: { ar: "جاري التصدير...", en: "Exporting..." },
  exportSuccess: { ar: "تم التصدير بنجاح", en: "Export complete" },
  exportFailed: { ar: "فشل التصدير", en: "Export failed" },
  exportFoodsDesc: { ar: "تم تنزيل جميع سجلات الأطعمة كملف CSV", en: "Downloaded all food records as CSV" },
  exportUsersDesc: { ar: "تم تنزيل جميع سجلات المستخدمين كملف CSV", en: "Downloaded all user records as CSV" },
  addFoodTitle: { ar: "إضافة طعام جديد", en: "Add New Food" },
  addFoodSub: { ar: "أدخل تفاصيل الطعام لإضافته إلى قاعدة البيانات.", en: "Fill in the details to add a new food to the database." },
  editFoodTitle: { ar: "تعديل طعام", en: "Edit Food" },
  editFoodSub: { ar: "تعديل تفاصيل سجل الطعام.", en: "Update details of the food record." },
  foodNameAr: { ar: "الاسم بالعربية", en: "Arabic Name" },
  foodNameEn: { ar: "الاسم بالإنجليزية", en: "English Name" },
  foodCategory: { ar: "التصنيف", en: "Category" },
  foodReason: { ar: "السبب", en: "Reason" },
  foodNotes: { ar: "ملاحظات", en: "Notes" },
  foodAlreadyExists: { ar: "هذا الطعام موجود بالفعل في قاعدة البيانات.", en: "This food already exists in the database." },
  createFoodBtn: { ar: "إنشاء الطعام", en: "Create Food" },

  // Settings page
  apiConnection: { ar: "إعدادات الاتصال", en: "API Connection" },
  appConfig: { ar: "إعدادات التطبيق", en: "App Configuration" },
  connected: { ar: "متصل", en: "Connected" },
  disconnected: { ar: "غير متصل", en: "Disconnected" },
  saveUrl: { ar: "حفظ العنوان", en: "Save URL" },
  freeDailyLimit: { ar: "الحد الشهري المجاني (قديم)", en: "Free Monthly Limit (legacy)" },

  // User Activity History
  userHistory: { ar: "سجل نشاط المستخدم", en: "User Activity History" },
  userHistoryDesc: { ar: "السجل الزمني للأحداث وعمليات البحث وإجراءات الإدارة", en: "Chronological history of events, searches, and administrative actions" },
  subscriptionTab: { ar: "الاشتراك", en: "Subscription" },
  historyTab: { ar: "سجل النشاط", en: "Activity History" },
  overviewTab: { ar: "نظرة عامة", en: "Overview" },
  allEvents: { ar: "جميع الأحداث", en: "All Events" },
  catAuth: { ar: "المصادقة والأمان", en: "Authentication" },
  catSearch: { ar: "البحث الغذائي", en: "Food Search" },
  catImage: { ar: "فحص الصور", en: "Image Analysis" },
  catIngredients: { ar: "فحص الملصقات والمكونات", en: "Ingredients & Labels" },
  catSubscription: { ar: "الاشتراكات", en: "Subscription" },
  catPayment: { ar: "المدفوعات", en: "Payment" },
  catNotification: { ar: "الإشعارات", en: "Notifications" },
  catAdmin: { ar: "إجراءات الإدارة", en: "Admin Actions" },
  catProfile: { ar: "الملف الشخصي", en: "Profile" },
  catError: { ar: "الأخطاء", en: "Errors" },
  catSystem: { ar: "النظام", en: "System" },
  noHistoryYet: { ar: "لا يوجد سجل نشاط متاح حتى الآن.", en: "No history available yet." },
  dateFrom: { ar: "من تاريخ", en: "From Date" },
  dateTo: { ar: "إلى تاريخ", en: "To Date" },
  clearFilters: { ar: "مسح الفلاتر", en: "Clear Filters" },
  eventDetails: { ar: "تفاصيل الحدث", en: "Event Details" },
  actor: { ar: "المنفّذ", en: "Actor" },
  timestamp: { ar: "الوقت", en: "Timestamp" },
  metadata: { ar: "البيانات الإضافية", en: "Metadata" },
  rawDetails: { ar: "التفاصيل التقنية", en: "Technical Details" },

  // User Report Feature
  userReport: { ar: "تقرير المستخدم", en: "User Report" },
  userReportDesc: { ar: "تقرير شامل لنشاط المستخدم وإحصائيات البحث والاشتراكات", en: "Comprehensive report of user activity, search stats, and subscriptions" },
  openReportModal: { ar: "عرض التقرير الشامل", en: "Open Full Report" },
  userReportTitle: { ar: "تقرير المستخدم والنشاط والاشتراك", en: "User Activity & Subscription Report" },
  activitySummary: { ar: "ملخص النشاط", en: "Activity Summary" },
  totalActivityEvents: { ar: "إجمالي أحداث النشاط", en: "Total Activity Events" },
  totalSearches: { ar: "إجمالي عمليات البحث", en: "Total Searches" },
  foodSearches: { ar: "البحث الغذائي النصي", en: "Food Searches" },
  imageAnalyses: { ar: "فحص الصور", en: "Image Analyses" },
  ingredientAnalyses: { ar: "فحص الملصقات والمكونات", en: "Ingredient Analyses" },
  loginCount: { ar: "مرات تسجيل الدخول", en: "Logins" },
  lastActive: { ar: "آخر نشاط", en: "Last Active" },
  searchBreakdown: { ar: "تفصيل أنواع البحث", en: "Search Breakdown" },
  recentSearches: { ar: "أحدث عمليات البحث", en: "Recent Searches" },
  subscriptionSummary: { ar: "ملخص الاشتراك", en: "Subscription Summary" },
  subscriptionHistory: { ar: "سجل الاشتراكات", en: "Subscription History" },
  currentPlan: { ar: "الخطة الحالية", en: "Current Plan" },
  subStatus: { ar: "حالة الاشتراك", en: "Subscription Status" },
  subSource: { ar: "مصدر الاشتراك", en: "Subscription Source" },
  startDate: { ar: "تاريخ البدء", en: "Start Date" },
  expirationDate: { ar: "تاريخ الانتهاء", en: "Expiration Date" },
  daysRemaining: { ar: "الأيام المتبقية", en: "Days Remaining" },
  autoRenew: { ar: "التجديد التلقائي", en: "Auto Renew" },
  noActiveSub: { ar: "لا يوجد اشتراك نشط (حساب مجاني)", en: "No active subscription (Free Account)" },
  activeSub: { ar: "اشتراك نشط", en: "Active Subscription" },
  expiredSub: { ar: "اشتراك منتهي", en: "Expired Subscription" },
  adminGrant: { ar: "منحة إدارية", en: "Admin Grant" },
  googlePlay: { ar: "Google Play", en: "Google Play" },
  userReportBtn: { ar: "تقرير المستخدم", en: "User Report" },
  directionToggle: { ar: "اتجاه ولغة التقرير", en: "Report Direction & Language" },
  notAvailable: { ar: "غير متوفر", en: "N/A" },
  planLimits: { ar: "حدود الخطة", en: "Plan Limits" },
  activityTimeline: { ar: "الجدول الزمني للنشاط", en: "Activity Timeline" },
  viewAllHistory: { ar: "عرض كل سجل النشاط", en: "View All Activity History" },
  allSearches: { ar: "جميع عمليات البحث", en: "All Searches" },
} as const;

export function tr(lang: Lang, key: keyof typeof T | (string & {})): string {
  const entry = (T as Record<string, { ar: string; en: string }>)[key];
  if (!entry) {
    if (import.meta.env.DEV) {
      console.warn(`[i18n] Missing translation key: ${String(key)}`);
    }
    return String(key);
  }
  return entry[lang] ?? entry.en ?? String(key);
}
